import type { ServiceEntry } from '@/types/domain';
import { useCallback } from 'react';
import { useFirestoreCollection, type FirestoreConstraintsBuilder } from './useFirestoreCollection';

export function useServiceEntries(vehicleId: string | null | undefined) {
  const buildConstraints = useCallback<FirestoreConstraintsBuilder>(
    (sdk) => [sdk.orderBy('performedAt', 'desc')],
    [],
  );
  return useFirestoreCollection<ServiceEntry>(
    vehicleId ? `vehicles/${vehicleId}/service` : null,
    buildConstraints,
  );
}
